export const capitalizeFirstLetter = (string) => (!string ? '' : string.charAt(0).toUpperCase() + string.slice(1));
export const toTitle = (string, key) => (key === 0 ? (string || '').charAt(0).toUpperCase() + (string || '').slice(1) : string);
export const snakeCaseToTitle = (string) => (string || '').split('_').map(toTitle).join(' ');
